// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"eef44ace","110":"4e537b41","739":"0ae44a5d","871":"2e68991d"}[chunkId] + ".chunk.css";
};